import React, { useContext } from 'react';
import { useTheme } from '@mui/material/styles';
import { IconProps } from './iconProps';
import { UiContext } from 'shared/lib/contexts/uiContext';
import cx from 'classnames';
import { defaultSpacingPresets } from 'shared/hooks/useGetSpacing';

export default function IconBurger({
  extColor,
  isAutoscallable = true,
  sizeKey = '24x24',
  onClick,
  style,
}: IconProps) {
  const theme = useTheme();
  const fill = extColor || theme.palette.primary.main;
  const {
    spacings: {
      icons: { [sizeKey]: size },
    },
  } = useContext(UiContext);

  const w = isAutoscallable ? size.w : defaultSpacingPresets.icons[sizeKey].w;
  const h = isAutoscallable ? size.h : defaultSpacingPresets.icons[sizeKey].h;

  return (
    <svg
      className={cx('icon', { 'icon-disabled': !onClick })}
      onClick={onClick}
      style={style}
      width={w}
      height={h}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="2" y="4" width="20" height="3.23077" rx="1.61538" />
      <rect x="2" y="10.3845" width="20" height="3.23077" rx="1.61538" />
      <rect x="2" y="16.7695" width="20" height="3.23077" rx="1.61538" />
    </svg>
  );
}
